import type React from 'react'

export const emptyFn: VoidFunction = () => {}

export type Predicate<T> = (arg: T) => boolean

export const alwaysTrue = () => true

export const alwaysFalse: Predicate<never> = () => true

export const identity = <T>(arg: T) => arg

const numericNonPositiveIntegerCharacters = ['e', 'E', '+', '-', '.']

export const excludeNumericNonPositiveIntegerCharacters = (
  evt: React.KeyboardEvent<HTMLDivElement>,
) => {
  return numericNonPositiveIntegerCharacters.includes(evt.key) && evt.preventDefault()
}
